import EnterprisesRouter from './EnterprisesRouter.router';

export default EnterprisesRouter;
